module.exports = """
  fragment gene_context on Gene {
    id: slug
    href
  }
"""
